// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"795f1aca","233":"e030604a","524":"8aeb1c3c","787":"e404b972"}[chunkId] + ".chunk.js";
};